import { createStreamReducer } from 'widgets/store/stream/reducer';
import { WidgetStreamState } from 'widgets/store/stream/WidgetStreamState';
import {
    ParameterGroup,
    StrategyParametersElement,
    StrategyParametersSingleOrderElement,
} from 'communication/types/strategyParams/StrategyParametersElement';
import {
    initialStrategyParametersStreamState,
    StrategyParametersStreamDataState,
} from './StrategyParametersStreamState';

export const processStreamElement = (
    element: StrategyParametersElement,
    nextState: WidgetStreamState<StrategyParametersStreamDataState>,
    streamKey: string
) => {
    const nextDataState: StrategyParametersStreamDataState = nextState.data;

    populateStrategyParametersStreamData(element, nextDataState);

    if (nextDataState.orderSelection) {
        nextDataState.streamKeys = {
            ...nextDataState.streamKeys,
            [nextDataState.orderSelection]: streamKey,
        };
    }
};

export function populateStrategyParametersStreamData(
    element: StrategyParametersElement,
    nextDataState: Pick<
        StrategyParametersStreamDataState,
        'orderSelection' | 'paramGroups'
    >
) {
    if (isSingleOrderElement(element)) {
        nextDataState.orderSelection = 'single';

        const singleOrderElement =
            element as StrategyParametersSingleOrderElement;
        switch (singleOrderElement.t) {
            case 'refresh':
                nextDataState.paramGroups = singleOrderElement.a
                    ? singleOrderElement.a
                    : [{}];
                break;
            case 'update':
                nextDataState.paramGroups = [
                    ...nextDataState.paramGroups,
                    ...singleOrderElement.a,
                ];
                break;
        }
    } else {
        nextDataState.orderSelection = 'multiple';
        nextDataState.paramGroups = [element as ParameterGroup];
    }
}

function isSingleOrderElement(element: StrategyParametersElement) {
    const singleOrderElement: StrategyParametersSingleOrderElement =
        element as StrategyParametersSingleOrderElement;
    return (
        singleOrderElement.t &&
        (singleOrderElement.t === 'refresh' ||
            singleOrderElement.t === 'update')
    );
}

export const strategyParametersStreamReducer = createStreamReducer<
    StrategyParametersStreamDataState,
    StrategyParametersElement
>(initialStrategyParametersStreamState, processStreamElement);
